
import React from 'react';
import styles from './style/index.less';
import DfPrice from '@/components/dFPrice';
import {toPrice} from '@/utils/price';
import fd from './images/fudou.png';
import close from './images/close.png';
import {TLang, ReplaceText} from '@/utils/lang';
import DFDiscount from '@/components/dfDiscount';
const SiteList = (props) => {
  const { data, maxSit, deleItem, purchaseLimitDTO, lowPriceTag} = props;

  return (
    <div className={styles.choose} >
      {
        data&&data.length<=0?<div className={styles.chooseTitle}>{purchaseLimitDTO?.isGrey ? purchaseLimitDTO?.passDesc : ReplaceText('X', maxSit, TLang('最多可选X个座位', 'home', false, false, null), false)}</div>:null
      }
      <div className={styles.choosePoint}>
        {
          data.map((e, idx, arr) => (<div key={`${idx}a`}  className={styles.point}  onClick={() => deleItem(e, idx)}>
            <div className={styles.pointLeft}>
              <p style={{textIndent: '0'}}>
                {lowPriceTag? <DFDiscount style={{ top: '-0.01rem', textIndent: 0, marginRight: '0.06rem', height: '0.28rem', fontSize: '0.24rem', lineHeight: '0.28rem', padding: '0.02rem'}} /> : null}
                {e.info}</p>
              <div style={{ display: 'flex'}}>
                <DfPrice price={e.price} iconCls="md" textStyles={{'marginLeft':'-0.06rem', color:'rgb(244, 69, 69)'}}/>
                {/* <p> <img className={styles.fudou} src={fd} /> {toPrice(e.price)}</p> */}
                {/* {lowPriceTag? <DFDiscount style={{ top: '0', textIndent: 0}} /> : null} */}
              </div>
            </div>
            <div  className={styles.pointRight}> <img className={styles.close} src={close} /> </div>
          </div>))
        }
      </div>
    </div>
  );
};
export default SiteList;
